import React from 'react';
import { Carousel } from 'antd';
import './Banner.css'
import {
    Typography,
    Button
} from '@material-ui/core'
import NavLink from '../../../../Helpers/NavLink/NavLink';

const Banner = () => {

    return (
        <div>
            <Carousel >
                <div className="banner">
                    <img src="/Img/bannerImage.jpg" alt="Banner" className="img-responsive" />
                    <div className="banner-content">
                        <Typography
                            variant='h6'
                            gutterBottom
                        >
                            iesh AYurveda
                        </Typography>
                        <Typography
                            variant='body2'
                            gutterBottom
                        >
                            iesh Ayurveda looking forward to achieve those life goals to each and every person who believes us. We believe the <b>"The Beauty Of Health"</b> of a person in the internal and external well being...
                        </Typography>
                        {
                            localStorage.getItem('Token') ? '' : (<NavLink to="/signUp"> <Button
                                className="registerButton"
                                size="small"
                                type='submit'
                                variant='contained'
                                color='primary'
                                disableElevation
                            >
                                Register
                            </Button></NavLink>)
                        }

                    </div>
                </div>
            </Carousel>
        </div>
    )
}

export default Banner
